import ContactDepartment from './ContactDepartment'
import ContactFunction from './ContactFunction'
import UpdateNeeded from './UpdateNeeded'
export class ContactInfo {
    constructor(obj?: object) {
        if (obj) {
            for (let prop in obj) {
                this[prop] = obj[prop];
            }
        }
        
    }
    RequestID: number;
    ID?: number;
    ContactPersonName: string;
    ContactPhoneNumber: string;
    ContactPhoneExtension: string;
    SecondaryContactName: string;
    SecondaryContactPhoneNumber: string;
    FirstName: string;
    LastName: string;
    ContactPartnerNumber: string;
    AlternateContactPhoneNumber: string;
    AlternateContactPhoneExtension: string;
    Email: string;
    ContactFaxNumber: string;
    ContactDepartmentID?: number;
    ContactFunctionID?: number;
    ContactDepartment?: ContactDepartment;
    ContactFunction?: ContactFunction;
    UpdateNeededID?: number;
    UpdateNeeded?: UpdateNeeded;
    AppliesToCustomer?: boolean;
    AppliesToPayer?: boolean;
    AppliesToDisplayValue: string;
    AppliesToDisplayField?: boolean;
    CopyOverallAccountEmail?: boolean;
    CopyOverallAccountPhoneNumber?: boolean;

    isMatch(other: ContactInfo) : boolean {
        
        let id = this.ID ? this.ID : "";
        let lastName = this.LastName ? this.LastName : "";
        let firstName = this.FirstName ? this.FirstName : "";

        let otherId = other.ID ? other.ID : "";
        let otherLastName = other.LastName ? other.LastName : "";
        let otherFirstName = other.FirstName ? other.FirstName : "";
        
        if (id != "" && otherId != ""){
            if (id == otherId) {
                return true;
            }
        }

        if (lastName.toUpperCase() != otherLastName.toUpperCase()) {
            return false;
        }

        if (firstName.toUpperCase() != otherFirstName.toUpperCase()) {
            return false;
        }
        
        return true;
    }
    setAppliesToDisplayValue() : string {
        if(this.AppliesToCustomer == true && this.AppliesToPayer == true){
            this.AppliesToDisplayValue = 'Both'
        }
        else if(this.AppliesToCustomer == true){
            this.AppliesToDisplayValue = 'Customer'
        }
        else if(this.AppliesToPayer == true){
            this.AppliesToDisplayValue = 'Payer'
        }
        else {
            this.AppliesToDisplayValue = "None";
        }
        return this.AppliesToDisplayValue;
        
    }
}

export default ContactInfo;